import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecabs() {



  const cardData =
  {
    keyword: 'Mumbai Airport to Pune Cabs ',
    heading: 'Shambhu Cabs: Mumbai Airport to Pune Cabs',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai Airport to Pune Cabs, providing safe, comfortable, and hassle-free airport transfer services for families, corporate travelers, business executives, and groups traveling between Mumbai and Pune. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and timely journey from Mumbai Airport to Pune with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes airport travel convenient, punctual, and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai Airport to Pune cab services for travelers seeking comfort, safety, and a reliable transfer experience.',

    top: 'Top Places to Visit in Pune with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
],




"services": [
  {
    "name": "Mumbai Airport Pune Taxi",
    "description": "Mumbai Airport Pune Taxi provides a convenient and reliable transfer service from Mumbai airport to Pune. Ideal for business travelers, tourists, and families, this service ensures timely pickup from airport terminals, comfortable seating, and smooth highway travel. Drivers are experienced in airport transfers and long-distance routes, offering a stress-free journey with professional service and transparent pricing."
  },
  {
    "name": "Airport Pickup Cab to Pune",
    "description": "Airport Pickup Cab to Pune specializes in seamless airport-to-city travel, offering door-to-door service for passengers landing at Mumbai’s T1 or T2 terminals. The service prioritizes punctuality, comfort, and safety, with GPS-enabled navigation to avoid traffic delays and ensure a timely arrival in Pune."
  },
  {
    "name": "Mumbai T2 to Pune Cab",
    "description": "Mumbai T2 to Pune Cab offers dedicated airport pickup from Terminal 2, providing a smooth and comfortable ride for solo travelers, families, and corporate clients. With professional chauffeurs, clean vehicles, and real-time tracking, this service guarantees reliable transfers from the airport to Pune’s key locations."
  },
  {
    "name": "One-Way Cab Mumbai Airport Pune",
    "description": "One-Way Cab Mumbai Airport Pune is perfect for passengers seeking single-direction travel without paying for a return trip. Ideal for business trips, relocations, or personal travel, this service ensures economical pricing, safe driving, and efficient routes from the airport to Pune."
  },
  {
    "name": "Affordable Airport Cab Mumbai Pune",
    "description": "Affordable Airport Cab Mumbai Pune provides budget-friendly transfers from Mumbai airport to Pune without compromising on comfort or safety. Passengers benefit from transparent fare estimates, well-maintained vehicles, and professional drivers experienced in long-distance airport journeys."
  },
  {
    "name": "Sedan Airport Cab Mumbai Pune",
    "description": "Sedan Airport Cab Mumbai Pune offers comfortable and elegant sedans for airport transfers. Ideal for couples, small families, or business travelers, sedans ensure a smooth ride with air-conditioning, spacious seating, and reliable service from the airport to Pune."
  },
  {
    "name": "SUV Cab Mumbai Airport Pune",
    "description": "SUV Cab Mumbai Airport Pune provides spacious, premium vehicles for passengers traveling with family or luggage. SUVs deliver extra comfort, enhanced safety, and smooth long-distance performance, making them perfect for airport pickups and extended road travel to Pune."
  },
  {
    "name": "24×7 Airport Taxi Mumbai Pune",
    "description": "24×7 Airport Taxi Mumbai Pune guarantees round-the-clock availability for airport transfers. Whether arriving at late-night or early-morning flights, passengers can rely on prompt pickups, professional chauffeurs, and uninterrupted service to Pune at any time."
  },
  {
    "name": "Fast Cab Mumbai Airport Pune",
    "description": "Fast Cab Mumbai Airport Pune ensures quick and efficient travel from Mumbai airport to Pune. The service uses optimized highway routes, real-time traffic monitoring, and experienced drivers to minimize travel time while maintaining safety and comfort for passengers."
  },
  {
    "name": "Best Cab Mumbai Airport Pune",
    "description": "Best Cab Mumbai Airport Pune provides premium quality vehicles and professional chauffeurs for airport-to-Pune transfers. Known for punctuality, excellent service, and clean cars, this option ensures a hassle-free and enjoyable journey for all types of passengers."
  },
  {
    "name": "Expressway Cab Pune",
    "description": "Expressway Cab Pune specializes in fast and smooth travel along the Mumbai-Pune Expressway. Passengers benefit from comfortable vehicles, skilled drivers, and scenic highway views while enjoying a safe and swift journey from the airport to Pune city."
  },
  {
    "name": "Premium Airport Cab Mumbai Pune",
    "description": "Premium Airport Cab Mumbai Pune offers high-end sedans and SUVs with luxury interiors and chauffeur-driven service. Perfect for corporate travelers, VIP clients, or families seeking maximum comfort and style during their airport transfer to Pune."
  },
  {
    "name": "Corporate Airport Cab Mumbai Pune",
    "description": "Corporate Airport Cab Mumbai Pune caters to business professionals needing efficient, punctual, and comfortable airport transfers. The service includes premium vehicles, professional drivers, and optional billing solutions for corporate clients traveling between Mumbai airport and Pune offices."
  },
  {
    "name": "Safe Taxi Mumbai Airport Pune",
    "description": "Safe Taxi Mumbai Airport Pune emphasizes passenger safety through trained chauffeurs, GPS tracking, sanitized vehicles, and cautious highway driving. Ideal for families, solo travelers, and senior citizens, this service ensures a secure and stress-free transfer experience."
  },
  {
    "name": "Airport Transfer Cab Mumbai Pune",
    "description": "Airport Transfer Cab Mumbai Pune provides seamless door-to-door pickup from Mumbai airport to any location in Pune. Flexible booking, transparent pricing, and professional drivers make this service convenient for travelers with tight schedules or heavy luggage."
  },
  {
    "name": "Family Cab Mumbai Airport Pune",
    "description": "Family Cab Mumbai Airport Pune is tailored for families traveling together from Mumbai airport to Pune. With spacious seating, luggage-friendly vehicles, and comfortable interiors, this service ensures a relaxed journey suitable for all age groups."
  },
  {
    "name": "Mumbai Airport to Pimpri Pune Cab",
    "description": "Mumbai Airport to Pimpri Pune Cab offers specialized transfers to the Pimpri-Chinchwad region, catering to business hubs, residential areas, and industrial zones. Passengers enjoy direct routes, professional drivers, and timely arrivals for both personal and corporate travel needs."
  }
],

"tableData": [
  ["Mumbai Airport Pune Taxi", "Airport Pickup Cab to Pune"],
  ["Mumbai T2 to Pune Cab", "One-Way Cab Mumbai Airport Pune"],
  ["Affordable Airport Cab Mumbai Pune", "Sedan Airport Cab Mumbai Pune"],
  ["SUV Cab Mumbai Airport Pune", "24×7 Airport Taxi Mumbai Pune"],
  ["Fast Cab Mumbai Airport Pune", "Best Cab Mumbai Airport Pune"],
  ["Expressway Cab Pune", "Premium Airport Cab Mumbai Pune"],
  ["Corporate Airport Cab Mumbai Pune", "Safe Taxi Mumbai Airport Pune"],
  ["Airport Transfer Cab Mumbai Pune", "Family Cab Mumbai Airport Pune"],
  ["Mumbai Airport to Pimpri Pune Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Airport to Pune Cabs with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai Airport to Pune cab services, ideal for airport transfers, business trips, and comfortable travel to Pune city."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey from Mumbai Airport to Pune."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Airport Transfers",
    "WhyChoosedescription": "Our professional drivers are experienced in Mumbai Airport routes, ensuring timely, safe, and hassle-free travel to Pune."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai Airport to Pune cab booking stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and flight schedule updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Airport Transfers",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai Airport to Pune travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your journey from Mumbai Airport to Pune smooth and comfortable."
  }
]






























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai Airport to Pune cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable cab services from Mumbai Airport to Pune with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai Airport to Pune cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai Airport to Pune cab bookings?',
    answer: 'Shambhu Cabs offers sedans, SUVs, and premium cars suitable for a comfortable and smooth journey from Mumbai Airport to Pune.',
  },
  {
    question: 'Are drivers experienced for the Mumbai Airport to Pune route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai Airport to Pune route to ensure a safe and hassle-free journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai Airport to Pune cab?',
    answer: 'Absolutely. You can choose your preferred pickup location at Mumbai Airport and select any drop-off point in Pune.',
  },
  {
    question: 'Is the Mumbai Airport to Pune cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab services from Mumbai Airport to Pune to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai Airport to Pune cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene guidelines for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai Airport to Pune cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai Airport to Pune journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your travel from Mumbai Airport to Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshmukh',
    feedback: 'The Mumbai Airport to Pune cab service with Shambhu Cabs was smooth and comfortable. The driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Highly reliable service! Clean car, timely pickup from Mumbai Airport, and a hassle-free ride to Pune.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cabs",
  "image": "https://www.shambhucab.com/assets/images/mumbai-airport-to-pune-cab.jpg",
  "description": "Shambhu Cabs offers safe, reliable, and comfortable Mumbai Airport to Pune cab services. Book one-way or round trips with sedans, SUVs, or premium cars for airport transfers, family travel, corporate trips, and expressway journeys. Enjoy 24×7 availability, fast travel, and convenient pickup-drop including Mumbai Airport T2 to Pimpri Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-airport-to-pune-cabs"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai Airport to Pune Cabs | Airport Pickup & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Pune cab with Shambhu Cabs. Safe, affordable, and comfortable service for airport transfers, family trips, corporate travel, and expressway journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop from Mumbai Airport T2 to Pimpri Pune."
  />

  <meta
    name="keywords"
    content="Mumbai Airport Pune Taxi, Airport Pickup Cab to Pune, Mumbai T2 to Pune Cab, One-Way Cab Mumbai Airport Pune, Affordable Airport Cab Mumbai Pune, Sedan Airport Cab Mumbai Pune, SUV Cab Mumbai Airport Pune, 24×7 Airport Taxi Mumbai Pune, Fast Cab Mumbai Airport Pune, Best Cab Mumbai Airport Pune, Expressway Cab Pune, Premium Airport Cab Mumbai Pune, Corporate Airport Cab Mumbai Pune, Safe Taxi Mumbai Airport Pune, Airport Transfer Cab Mumbai Pune, Family Cab Mumbai Airport Pune, Mumbai Airport to Pimpri Pune Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecabs;